import { render, staticRenderFns } from "./HistoryBlock.vue?vue&type=template&id=58a30700"
import script from "./HistoryBlock.vue?vue&type=script&lang=js"
export * from "./HistoryBlock.vue?vue&type=script&lang=js"
import style0 from "./HistoryBlock.vue?vue&type=style&index=0&id=58a30700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports